import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { MediaScannerService } from 'media/services/mediaScanner.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { NotifyService } from 'common/util/services/notify.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class RescanOp extends BaseOperation {
  icon = 'far fa-sync'
  showInOverflowMenu = true
  showInContextMenu = true
  supportsDirs = true
  weight = 0

  constructor (
    private translate: TranslateService,
    private mediaPermissions: MediaPermissionsService,
    private mediaScanner: MediaScannerService,
    private notify: NotifyService,
  ) {
    super()
    this.label = translate.instant('Rescan recursively')
  }

  isVisibleForDir (dir) {
    return this.mediaPermissions.getPermissionForFile(dir)?.allowWriteDb ?? false
  }

  isEnabledForDir (dir) {
    return dir.present
  }

  async runForDir (dir) {
    await this.mediaScanner.rescan(dir.fullPath, true)
    this.notify.info(this.translate.instant('Rescan started'))
  }
}

MediaOperationsService.register(RescanOp)
